import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
const stagger = {
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
export function SolutionSection() {
  const deliverables = [{
    title: 'La Guía Maestra (PDF)',
    desc: 'Todo sobre la Edición 2026 y los nuevos aumentos por costo de vida explicados de forma sencilla.'
  }, {
    title: 'El Semáforo del Retiro',
    desc: 'Una herramienta visual para saber exactamente a qué edad le conviene tomar la mejor decisión financiera.'
  }, {
    title: 'Protocolo de Viudez y Divorcio',
    desc: 'Cómo reclamar el dinero de una ex-pareja sin que él se entere y sin afectarlo a él en lo absoluto.'
  }, {
    title: 'Checklist de Documentos',
    desc: 'Para que el día de su cita usted sea la persona más preparada en la oficina, evitando demoras.'
  }, {
    title: 'Guía de Optimización Financiera',
    desc: 'Estrategias para evitar que le quiten parte de su cheque ganado con tanto esfuerzo.'
  }];
  return <section className="relative" data-id="element-183">
      {/* Top half: Navy background for the mechanism */}
      <div className="bg-[#1B2A4A] pt-20 pb-40 px-4 sm:px-6 lg:px-8 text-center" data-id="element-184">
        <div className="max-w-3xl mx-auto" data-id="element-185">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-186">
            <span className="text-[#E8D5A3] font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-187">
              El Mecanismo Único
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#C5A55A] mb-8" data-id="element-188">
              El Mapa de Beneficios Cruzados
            </h2>
            <p className="text-xl text-white/90 leading-relaxed" data-id="element-189">
              Un método diseñado exclusivamente para la mujer hispana que le
              permite identificar visualmente si le conviene más cobrar por sus
              propios créditos, por los de su esposo actual, o incluso por los
              de un ex-esposo,{' '}
              <strong className="text-[#E8D5A3]" data-id="element-190">
                para obtener el cheque más alto que la ley permite.
              </strong>
            </p>
          </motion.div>
        </div>
      </div>

      {/* Bottom half: Deliverables overlapping the background */}
      <div className="bg-[#FDF8F0] pb-20 px-4 sm:px-6 lg:px-8" data-id="element-191">
        <div className="max-w-4xl mx-auto -mt-24 relative z-10" data-id="element-192">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} variants={stagger} className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-193">
            <motion.h3 variants={fadeIn} className="text-2xl md:text-3xl font-bold text-[#1B2A4A] mb-8 text-center border-b border-gray-100 pb-6" data-id="element-194">
              Lo que usted recibirá hoy:
            </motion.h3>

            <div className="space-y-6" data-id="element-195">
              {deliverables.map((item, index) => <motion.div key={index} variants={fadeIn} className="flex gap-4 items-start p-4 rounded-lg hover:bg-[#FDF8F0] transition-colors" data-id="element-196">
                  <CheckCircle className="w-8 h-8 text-[#C5A55A] shrink-0 mt-1" data-id="element-197" />
                  <div data-id="element-198">
                    <h4 className="text-xl font-bold text-[#2D2D2D] mb-1" data-id="element-199">
                      {item.title}
                    </h4>
                    <p className="text-gray-600 leading-relaxed" data-id="element-200">{item.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}